import {apiV2} from 'sources/api';
import {List} from 'immutable';
import Scorecard, {pascalToSnakeScoringScheme} from 'records/Scorecard';

export default {
  fetchAll() {
    return apiV2
      .getJson('/admin/scorecards')
      .then(({scorecards}) => List(scorecards.map(scorecard => new Scorecard(scorecard))));
  },
  fetch(id) {
    return apiV2.getJson(`/admin/scorecard/${id}`).then(scorecard => new Scorecard(scorecard));
  },
  create(scorecard) {
    const scorecardSchemeSnaked = scorecard.set(
      'scoringScheme',
      pascalToSnakeScoringScheme(scorecard.scoringScheme)
    );

    return apiV2
      .postJson(`/admin/scorecard`, scorecardSchemeSnaked.toJS())
      .then(scorecard => new Scorecard(scorecard));
  },
  update(scorecard) {
    const scorecardSchemeSnaked = scorecard.set(
      'scoringScheme',
      pascalToSnakeScoringScheme(scorecard.scoringScheme)
    );

    return apiV2
      .putJson(`/admin/scorecard/${scorecard.id}`, scorecardSchemeSnaked.toJS())
      .then(scorecard => new Scorecard(scorecard));
  },
};
